import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetcher } from "../services/api";
import { User } from "../interfaces/profile";

type UserContextType = {
  user: User | undefined;
  isLoading: boolean;
  should_ask_for_referrer_source: boolean;
  refetchUser: () => Promise<void>;
};

const UserContext = createContext<UserContextType>({
  user: undefined,
  isLoading: true,
  should_ask_for_referrer_source: false,
  refetchUser: async () => {},
});

export const UserProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<User>();
  const [isLoading, setIsLoading] = useState(true);
  const [shouldAskReferrer, setShouldAskReferrer] = useState(false);

  const fetchUser = useCallback(async () => {
    try {
      const res = await fetcher<{ data: User }>("/auth/me", {
        method: "GET",
      });

      if (res.data?.data) {
        setUser(res.data.data);
        setShouldAskReferrer(res.data.data.should_ask_for_referrer_source === true);
      }
    } catch (error) {
      console.error("Failed to fetch user:", error);
    } finally {
      setIsLoading(false);
      
    }
    
  }, []);


  const refetchUser = useCallback(async () => {
    setIsLoading(true);
    await fetchUser();
  }, [fetchUser]);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return (
    <UserContext.Provider
      value={{ user, isLoading, should_ask_for_referrer_source: shouldAskReferrer, refetchUser }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
